import { PRODUCT_BASICS_DETAILS_SERVER } from "@graphql/fragments/product/server/basic-details";
import { PRODUCT_ADDITIONAL_DETAILS_SERVER } from "@graphql/fragments/product/server/additional-details";

export const fetchProductDetailServer = `
  query product(
    $slug: String!
    $currency: String!
    $country: String = ""
    $storeNumber: String!
    $globalZone: Boolean
    $menuId: ID
    $viewingInsideByoMedley: Boolean
  ) {
    product(slug: $slug, storeNumber: $storeNumber, country: $country) {
      ...ProductBasicDetails
      ...ProductAdditionalDetails
      availableGlobally
      countries {
        id
        iso
      }
      currentCatalog {
        storeId
        state
      }
      brand(country: $country, globalZone: $globalZone) {
        id
        displayName: name
        key
      }
      vendorByCountry: vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone)
      {
        id
        displayName
        externalId
        holidayEndDate
        holidayNote
        holidayStartDate
        visible
      }
      validPrintTypes {
        name
      }
      variantLevelCommerce
      shippedFromStadium
      shippedSeparately
      allVariantsAvailableGlobally
      enabledTaxonIds(
        country: $country
        globalZone: $globalZone
        storeNumber: $storeNumber
        menuId: $menuId
      )
      purchasable
    }
  }
  ${PRODUCT_BASICS_DETAILS_SERVER}
  ${PRODUCT_ADDITIONAL_DETAILS_SERVER}
`;

//added catalog number for new swag flow product detail modal
export const fetchProductDetailServerWithNumber = `
  query product(
    $slug: String!
    $currency: String!
    $country: String = ""
    $storeNumber: String!
    $globalZone: Boolean
    $menuId: ID
    $viewingInsideByoMedley: Boolean
    $number: String!
  ) {
    product(slug: $slug, storeNumber: $storeNumber, country: $country) {
      ...ProductBasicDetails
      ...ProductAdditionalDetails
      availableGlobally
      countries {
        id
        iso
      }
      currentCatalog {
        storeId
        state
      }
      brand(country: $country, globalZone: $globalZone) {
        id
        displayName: name
        key
      }
      vendorByCountry: vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone)
      {
        id
        displayName
        externalId
        holidayEndDate
        holidayNote
        holidayStartDate
        visible
      }
      validPrintTypes {
        name
      }
      variantLevelCommerce
      shippedFromStadium
      shippedSeparately
      allVariantsAvailableGlobally
      enabledTaxonIds(
        country: $country
        globalZone: $globalZone
        storeNumber: $storeNumber
        menuId: $menuId
      )
      selectedForAutomatedDesign(number: $number)
      selectedColorOptionsForAutomatedDesign(number: $number) {
        id
      }
      purchasable
    }
  }
  ${PRODUCT_BASICS_DETAILS_SERVER}
  ${PRODUCT_ADDITIONAL_DETAILS_SERVER}
`;
